export const isPhoneNumberValid = (phoneNumber: string): boolean => {
    return phoneNumber.length > 6 && phoneNumber.length < 30;
};

export const isPhoneNumberFormatValid = (phoneNumber: string): boolean => {
    const regex = new RegExp(/^\+?[\d]{0,3}?[-()\s\d]{7,20}$/);
    return regex.test(phoneNumber);
};
